import React, { useEffect, useMemo, useState, useCallback } from 'react';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  // Button,
  Stack,
} from '@mui/material';
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// import { useHistory } from 'react-router-dom';
import { getProjectSecrets, removeProjectSecret } from 'actions/projectSecrets';
import toNiceTimestamp from 'util/toNiceTimestamp';

export default function ProjectSecrets({ project }) {
  // const history = useHistory();
  const [project_secrets, setProjectSecrets] = useState(null);
  // const [transitioningProjectMembers, setTransitioningProjectMembers] =
  //   useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    connector_id: false,
  });

  useEffect(() => {
    (async () => {
      if (project_secrets === null) {
        const res = await getProjectSecrets(project.id);
        setProjectSecrets(res);
      }
    })();
  }, [setProjectSecrets, project_secrets, project.id]);

  const deleteProjectSecret = useCallback(
    (project_secret) => async () => {
      // setTransitioningProjectMembers((prevTransitioningProjectMembers) => [
      //   ...prevTransitioningProjectMembers,
      //   project_member.customer_uuid,
      // ]);
      await removeProjectSecret(project.id, project_secret.name);
      setProjectSecrets((prevState) => {
        return [...prevState].filter(
          (secret) => secret.name !== project_secret.name
        );
      });
      // setTransitioningProjectMembers((prevTransitioningProjectMembers) =>
      //   prevTransitioningProjectMembers.filter(
      //     (id) => id !== project_member.customer_uuid
      //   )
      // );
    },
    [project]
  );

  const formatDateColumn = useCallback(({ value }) => {
    console.log(value);
    return toNiceTimestamp(value, true);
  }, []);

  const columns = useMemo(
    () => [
      {
        field: 'name',
        headerName: 'Name',
        type: 'string',
        flex: 1,
      },
      {
        field: 'created_by',
        headerName: 'Owner Name',
        type: 'string',
        flex: 0.5,
      },
      {
        field: 'createdAt',
        headerName: 'Created At',
        type: 'string',
        valueFormatter: formatDateColumn,
        flex: 0.5,
      },
      {
        field: 'updatedAt',
        headerName: 'Last Updated',
        type: 'string',
        valueFormatter: formatDateColumn,
        flex: 0.5,
      },

      {
        field: 'actions',
        headerName: 'Actions',
        type: 'actions',
        width: 80,
        getActions: (params) => [
          // <GridActionsCellItem
          //   icon={<EditIcon />}
          //   label='Edit'
          //   onClick={editProjectMember(params.row)}
          //   showInMenu
          // />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label='Remove'
            onClick={deleteProjectSecret(params.row)}
            showInMenu
          />,
        ],
      },
    ],
    [deleteProjectSecret, formatDateColumn]
  );

  const Toolbar = () => (
    <GridToolbarContainer>
      <Stack direction='row' spacing={1}>
        {/* <Button color='brand' variant='outlined' onClick={() => {}}>
          <Stack direction='row' spacing={1} alignItems='center'>
            <AddCircleOutlineIcon />
            <Typography variant='button' display='block' gutterBottom>
              Add
            </Typography>
          </Stack>
        </Button> */}

        <GridToolbarColumnsButton variant='outlined' />
        <GridToolbarFilterButton variant='outlined' />
      </Stack>
    </GridToolbarContainer>
  );
  console.log(project_secrets);
  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='panel1a-content'
        id='panel1a-header'
      >
        <Typography variant='h6' paragraph gutterBottom>
          Project Secrets
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div style={{ width: '100%' }}>
          <div style={{ display: 'flex', height: '100%' }}>
            <div style={{ flexGrow: 1 }}>
              <DataGrid
                autoHeight
                checkboxSelection
                getRowId={(row) => row.name}
                columns={columns}
                rows={project_secrets || []}
                components={{
                  Toolbar: Toolbar,
                }}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={(newModel) =>
                  setColumnVisibilityModel(newModel)
                }
              />
            </div>
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
}
